<template>
  <div>
    <h3>
      Authorization provided by
      {{ getVerification.request_data.applicant_first_name }}
      {{ getVerification.request_data.applicant_last_name }}
    </h3>
    <p class="submitted">Submitted at {{ formattedCreatedAt }}</p>
    <div class="authorization" style="padding: 30px;">
      <p>
        {{ getVerification.auth_data.authorization }}
      </p>
      <div style="margin-top: 20px;">
        <canvas
          v-if="getVerification.auth_data.type === 'draw'"
          width="500"
        ></canvas>
        <div v-else class="typed_signature">
          {{ getVerification.auth_data.signature }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SignaturePad from "signature_pad";
import moment from "moment";

import fonts from "@/assets/fonts.scss";

export default {
  data() {
    return {
      signaturePad: null
    };
  },
  computed: {
    ...mapGetters(["getVerification"]),
    formattedCreatedAt() {
      const date = moment(this.getVerification.created_at);
      return `${date.format("MM/DD/YYYY")} at ${date.format("h:mm:ss a")}`;
    }
  },
  mounted() {
    const canvas = document.querySelector("canvas");
    if (canvas) {
      this.signaturePad = new SignaturePad(canvas);
      this.signaturePad.fromData(this.getVerification.auth_data.signature);
      this.signaturePad.off();
    }
  }
};
</script>
<style scoped>
h3 {
  font-weight: 400;
  font-size: 32px;
  line-height: 34px;
  margin: 0px;
}
p {
  max-width: none;
  margin: 0px;
  padding: 0px;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  font-family: Helvetica Neue;
  white-space: pre-line;
}
.submitted {
  font-weight: 300;
  font-size: 24px;
  line-height: 34px;
  color: #545454;
  margin: 15px 0px;
}
canvas {
  margin: auto;
  display: block;
}
.authorization {
  background: white;
  border: 1px solid #3ec19d;
  box-sizing: border-box;
  border-radius: 8px;
}
.typed_signature {
  font-family: "KaushanScript";
  font-size: 25px;
  color: #000000;
  text-align: center;
}
@media (max-width: 768px) {
  h3 {
    font-weight: 400;
    font-size: 28px;
    line-height: 34px;
  }
  p {
    font-size: 16px;
  }
  .submitted {
    font-size: 16px;
  }
}
</style>
